import { createApi } from '@reduxjs/toolkit/query/react';

import { User, UsersPayload } from '@/slices/account/account.types';

import { symfonyBaseQuery } from '@/services/SymfonyClient';

export const accountApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api/admin',
  }),
  reducerPath: 'account',
  tagTypes: ['Account'],
  endpoints: (build) => ({
    getUsers: build.query<User[], void>({
      query: () => ({
        url: '/users',
        method: 'GET',
      }),
      transformResponse: (response: UsersPayload) => response.users ?? [],
      providesTags: (result) => [
        { type: 'Account', id: 'LIST' },
        ...(result ?? []).map(({ id }) => ({ type: 'Account' as const, id })),
      ],
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          for (const user of data) {
            dispatch(
              accountApi.util.upsertQueryData(
                'getUser',
                { userId: user.id },
                user,
              ),
            );
          }
        } catch {
          // Ignore cache warmup when list query fails.
        }
      },
    }),
    getUser: build.query<
      User,
      {
        userId: string;
      }
    >({
      query: ({ userId }) => ({
        url: `/users/${userId}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, { userId }) => [
        { type: 'Account', id: userId },
      ],
    }),
  }),
});

export default accountApi;
